import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CompanyUserTodo,
  GetCompanyUserTodosResponse,
} from '../interfaces/company-user-todo';
import { Todo } from '../interfaces/todo';

@Injectable({
  providedIn: 'root',
})
export class TodosAdapter {
  private http = inject(HttpClient);

  getTodos(
    offset: number = 0,
    limit: number = 0,
    lastPoll: number = 0
  ): Observable<GetCompanyUserTodosResponse> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString())
      .set('lastPoll', lastPoll.toString());

    return this.http.get<GetCompanyUserTodosResponse>(
      `${environment.apiBaseUrl}/company/user/todos`,
      {
        params,
      }
    );
  }

  markAllAsDone(): Observable<void> {
    return this.http.patch<void>(`${environment.apiBaseUrl}/company/user/todos`, {});
  }

  toggleState(todo: Pick<CompanyUserTodo, 'id'> | Todo): Observable<void> {
    const done = 'done' in todo ? todo.done : true;

    return this.http.patch<void>(
      `${environment.apiBaseUrl}/company/user/todos/${todo.id}`,
      { done: !done }
    );
  }

  deleteAll(): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/company/user/todos`);
  }

  deleteTodo(todo: Pick<CompanyUserTodo, 'id'> | Todo): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiBaseUrl}/company/user/todos/${todo.id}`
    );
  }

  deleteTodos(todoIds: number[]): Observable<{ dismissed: number }> {
    return this.http.post<{ dismissed: number }>(
      `${environment.apiBaseUrl}/company/user/todos/bulk-dismiss`,
      { ids: todoIds }
    );
  }
}
